<template>
  <b-card>
    <b-col v-if="request">
      <b-alert variant="warning" :show="true">Caricamento dati nel periodo selezionato</b-alert>
    </b-col>
    <b-col v-else-if="!showCharts">
      <b-alert variant="warning" :show="true">Dati TEP non disponibili nel periodo selezionato</b-alert>
    </b-col>
    <b-row>
      <b-col>
        <apexchart height="400" type="bar" :options="chart.options" :series="chart.series"></apexchart>
      </b-col>
      <b-col>
        <apexchart height=400 type="pie" :options="pie.options" :series="pie.series"></apexchart>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table striped :items="tableData" :fields="tableHeaders"></b-table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: "TEPMonoSite",
  props: ['monthFrom', 'monthTo', 'site'],

  created() {
    this.refresh()
  },
  data() {
    return {
      request: false,
      show: false,
      showCharts: false,
      tableData: [],
      tableHeaders: [],
      chart: {
        options: {
          height: 350,
          type: 'bar',
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%'
            },
          },
          yaxis: {
            labels: {
              formatter: (x) => x.toFixed(0)
            }
          },
          dataLabels: {
            enabled: false
          },
        },
        series: []
      },
      pie: {
        options: {
          chart: {
            type: 'donut'
          },
          theme: {
            monochrome: {
              enabled: true
            }
          },
          labels: []
        },
        series: []
      }
    }
  },
  methods: {
    async refresh() {
      let params = {
        sitesGuids: [this.site.guid],
        fromMonth: this.monthFrom,
        toMonth: this.monthTo
      }

      this.request = true;
      this.chart.series = []
      this.pie.series = []

      try {
        const data = await this.$store.dispatch("charts/tep", params);

        // this.$toasted.show('TEP aggiornato', {duration: 3000, icon: 'check', theme: "bubble"})
        this.$notify({
          type: "success",
          text: "TEP aggiornato",
          title: 'Successo'
        }); 
        let skip = true
        data.items.forEach(i => {
          if (i.siteName)
            skip = false
        })

        this.showCharts = !skip
        if (skip) {
          this.request = false;
          return;
        }

        this.tableHeaders = [
          {TEP: {label: 'TEP', sortable: true}},
          /*{ P:  { label: "%" } }*/
        ]

        let chartHeaders = ['Vettore']
        let chartOptions = _.cloneDeep(this.chart.options)
        let pieOptions = _.cloneDeep(this.pie.options)

        data.vectors.forEach(v => {
          chartHeaders.push(v)
          this.tableHeaders.push(v)
          pieOptions.labels.push(v)
        })

        chartOptions.xaxis = {
          categories: data.vectors
        }


        this.chart.options = chartOptions
        this.pie.options = pieOptions

        this.tableData = []
        let item = data.items[0]
        if (item.siteName != null) {

          let row = [item.siteName]
          data.vectors.forEach(v => {
            row.push(item[v])
          })

          this.tableData.push({
            TEP: item.TEP.toFixed(2),
            //P : Math.round(item.rate) + "%",
            EE: item.EE.toFixed(2),
            GPL: item.GPL.toFixed(2),
            gas: item.gas.toFixed(2),
            Diesel: item.Diesel.toFixed(2),
          })

          var serieData = []

          data.vectors.forEach(v => {
            if (item[v] > 0)
              serieData.push(item[v])
          })

          this.chart.series.push({
            name: item.siteName,
            data: serieData
          })
          this.pie.series = serieData
        }
      } finally {
        this.request = false;
      }
    }
  },
  computed: {
    customer() {
      return this.$store.state.user.customerGuid
    },
    selectedMonths() {
      return this.months.map(m => parseInt(m))
    }
  },
  watch: {
    monthFrom(v) {
      this.refresh()
    },
    monthTo(v) {
      this.refresh()
    },
    customer(v) {
      if (v) {
        this.refresh()
      }
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Tep/MonoSite.vue